import clsx from "clsx";
import shape from "../../assets/img/shapes/plane-shape-01.webp";


const PlaneShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-plane-shape-01", props.className)}>
            <img src={shape} alt="rmdr-plane-shape-01" loading="lazy" width={197} height={112} />
        </div>
    )

}

export default PlaneShape01;
